import { SUPPRESSION_LIST_ABSTRACT_ROUTE, SL_ROUTES } from "app/pages/sales-intelligence/constants/sl_routes";
import LoadList from "app/pages/sales-intelligence/sub-modules/management/components/LoadList/LoadList";
import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

export const suppressionListConfig: RouterStateConfig = {
    [SL_ROUTES.upload]: {
        parent: SUPPRESSION_LIST_ABSTRACT_ROUTE,
        url: "/upload",
        component: LoadList,
        configId: "SalesWorkspace",
        trackingId: {
            section: "suppression list",
            subSection: "",
            subSubSection: "",
        },
        pageTitle: "si.pages.suppression_list.document_title",
        isSecondaryBarOpen: false,
        secondaryBarType: "SalesIntelligenceSuppressionList" as SecondaryBarType,
    },
};
